import { render, staticRenderFns } from "./Somos1V2RegionalIndicators1Page.vue?vue&type=template&id=6396f41a&scoped=true"
import script from "./Somos1V2RegionalIndicators1Page.ts?vue&type=script&lang=ts&external"
export * from "./Somos1V2RegionalIndicators1Page.ts?vue&type=script&lang=ts&external"
import style0 from "./Somos1V2RegionalIndicators1Page.vue?vue&type=style&index=0&id=6396f41a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396f41a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6396f41a')) {
      api.createRecord('6396f41a', component.options)
    } else {
      api.reload('6396f41a', component.options)
    }
    module.hot.accept("./Somos1V2RegionalIndicators1Page.vue?vue&type=template&id=6396f41a&scoped=true", function () {
      api.rerender('6396f41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1V2/page/Somos1V2RegionalIndicators1Page/Somos1V2RegionalIndicators1Page.vue"
export default component.exports